/* eslint-disable indent */
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { NavLink } from 'react-router-dom';

import './index.scss';

Modal.setAppElement('#root');

class Layover extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.state={
      name:''
    }
  }

  closeModal() {
    this.props.closeCampaignModel();
  }

  addCampaign = () =>{
    this.props.saveOutreachName(this.state.name);
    this.props.closeCampaignModel();
    this.props.history.push('/app/campaign');
  }

  handleChange = (event)=>{
    this.setState({
        name:event.target.value
      });
  }

  render() {
    const {modelopen} = this.props;
    return (
      <div>
        <Modal
          isOpen={modelopen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          className="Modal"
          overlayClassName="Overlay"
          contentLabel="Example Modal"
        >
          <div>
            <div className="modal-header">
              <div className="title">Add New Campaign</div>
              <button className="modal-close" onClick={this.closeModal}>X</button>
              <div className="input">
                <label className="label">Campaign Name</label>
                <input type="text" value={this.state.name} onChange={this.handleChange} maxlength="100"/>
              </div>
              <div className="actions">
                  <button className="btn btn--primary btn--lg" onClick={this.addCampaign} disabled={this.state.name.trim().length<1}>NEXT</button>
                  <button className="btn btn--secondary btn--lg" onClick={this.closeModal}>CANCEL</button>
              </div>
            </div>
          </div>
          {this.props.children}
        </Modal>
      </div>
    );
  }
}

export default Layover;

